<template>
  <div class="expande-horizontal column pt-0">
    <v-flex xs12>
      <div class="windows-style expande-horizontal fonte column">
        <transition name="slide-fade">
          <v-list-item class="pa-0 ma-0">
            <v-avatar
              @click="backToList"
              style="cursor: pointer;"
              size="27"
              :color="$theme.primary"
              class="mr-2"
              icon
            >
              <v-icon color="#f2f2f2">mdi-close</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ get_unidade.new ? "Novo polo" : get_unidade.nome }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-mini">
                Gerencie os detalhes abaixo
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </transition>
      </div>
    </v-flex>

    <div
      style="min-height: 80vh; max-height: 80vh;"
      class="windows-style-content expande-horizontal wrap"
    >
      <v-tabs
        v-model="tabs"
        :background-color="$theme.primary"
        dark
        class="fonte"
      >
        <v-tab>Info do Polo</v-tab>
        <v-tab @click="listClientSales">Vendas do polo</v-tab>
      </v-tabs>

      <v-flex v-if="tabs == 0" xs12>
        <v-form ref="form">
          <v-flex class="px-2" xs12>
            <v-text-field
              v-model="get_unidade.nome"
              filled
              label="Nome"
              clearable
              :color="$theme.primary"
              :rules="[v => !!v || 'Preencha este campo']"
              placeholder="ex: Polo Centro"
            ></v-text-field>
          </v-flex>

          <div class="expande-horizontal wrap">
            <v-flex class="px-2" xs12 md6>
              <v-text-field
                v-model="get_unidade.cnpj"
                label="CNPJ"
                filled
                clearable
                :color="$theme.primary"
                placeholder="ex: 00.000.000/0001-00"
              ></v-text-field>
            </v-flex>
            <v-flex class="px-2" xs12 md6>
              <v-text-field
                v-model="get_unidade.phone"
                label="Telefone"
                clearable
                filled
                :color="$theme.primary"
                placeholder="ex: (96) 9 8419-6827"
              ></v-text-field>
            </v-flex>
          </div>

          <v-flex class="px-2" xs12>
            <v-textarea
              v-model="get_unidade.descricao"
              label="Descricao do polo"
              filled
              clearable
              :color="$theme.primary"
            ></v-textarea>
          </v-flex>
        </v-form>
      </v-flex>

      <v-flex v-if="tabs == 1" xs12>
        <div class="expande-horizontal wrap">
          <h2 class="fonte-bold ml-3">
            O polo possui {{ sales.length }} vendas.
          </h2>
          <div
            style="min-height: 67vh; max-height: 67vh; overflow: auto;"
            class="expande-horizontal px-3"
            v-if="sales.length > 0"
          >
            <v-flex xs12 md3 class="mr-3" v-for="sale in sales" :key="sale._id">
              <SaleItem :kanban="sale" />
            </v-flex>
          </div>

          <div class="expande-horizontal centraliza" v-else>
            <span class="my-12 fonte">Este polo ainda nao possui vendas</span>
          </div>
        </div>
      </v-flex>
    </div>

    <div class="expande-horizontal py-1 windows-style-bottom">
      <v-btn large dark @click="valida_form" :color="$theme.primary">
        <span class="fonte"> Salvar </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import SaleItem from "@/apps/GestorDePedido/components/SaleItem.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    SaleItem
  },
  computed: {
    ...mapGetters(["get_unidade", "getLoggedUser"])
  },
  data() {
    return {
      tabs: 0,
      sales: []
    };
  },
  methods: {
    ...mapActions([
      "criar_unidade",
      "atualizar_unidade",
      "fecha_modal_view_unidade",
      "enableLoading",
      "disableLoading"
    ]),
    listClientSales() {
      this.enableLoading();
      this.$run("unidades/list-client-sales", {
        _id: this.get_unidade._id
      }).then(res => {
        this.disableLoading();
        this.sales = res.data;
      });
    },
    valida_form() {
      if (this.$refs.form.validate()) {
        this.get_unidade._id ? this.atualizar_unidade() : this.criar_unidade();
      }
    },
    backToList() {
      this.$store.commit("set_unidade", {});
      this.$forceUpdate();
    }
  }
};
</script>
